import { render } from "./PasswordModal.vue?vue&type=template&id=115534f6&scoped=true"
import script from "./PasswordModal.vue?vue&type=script&lang=js"
export * from "./PasswordModal.vue?vue&type=script&lang=js"

import "./PasswordModal.vue?vue&type=style&index=0&id=115534f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115534f6"]])

export default __exports__